import { dispatchTrack } from '@/utils/tracking';
import {
  TRACKING_OPERATION,
  TRACKING_PAGE,
  TRACKING_SECTION,
} from '@/utils/constants';

const config = {
  keyMap: {}, // 同步script标签引入的translation[LANG]
  lostKeys: new Set([]), // 不在同步script标签引入的translation中的key
  notAvailableKeys: new Set([]), // 异步script标签引入的extra_translation还没ready导致获取不到value的情况
};

function setKeyMap(keyMap = {}) {
  config.keyMap = keyMap;
}

function isInKeyMap(key) {
  return config.keyMap.hasOwnProperty(key);
}

function isKeyMapEmpty() {
  return Object.keys(config.keyMap).length === 0;
}

function collectLostKeys(key) {
  config.lostKeys.add(key);
}

function collectNotAvailableKeys(key) {
  config.notAvailableKeys.add(key);
}

function getKeysArr(size, set) {
  const arr = [];
  for (const key of set) {
    if (arr.length < size) {
      arr.push(key);
      set.delete(key);
    } else {
      break;
    }
  }
  return arr;
}

function report() {
  const size = 5;
  const lostKeysArr = getKeysArr(size, config.lostKeys);
  const notAvailableKeysArr = getKeysArr(size, config.notAvailableKeys);

  if (lostKeysArr.length || notAvailableKeysArr.length) {
    dispatchTrack({
      page_type: TRACKING_PAGE.MAIN_PAGE,
      operation: TRACKING_OPERATION.LOST_TRANSIFY_KEYS,
      section: TRACKING_SECTION.lostTransifyKeys,
      data: {
        lost_keys: lostKeysArr.join(','),
        not_available_keys: notAvailableKeysArr.join(','),
      },
    });
  }
}

export default {
  setKeyMap,
  isInKeyMap,
  collectLostKeys,
  collectNotAvailableKeys,
  report,
  isKeyMapEmpty,
};
